// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"197":"75fc9c18","293":"component---src-pages-index-js","461":"b637e9a5","518":"8a28b14e"}[chunkId] || chunkId) + "." + {"197":"7978642d929dd5ee05cb","293":"8584bcb1488094afd14b","461":"01410e9b18dbc446cbf9","518":"9b4ad95ae6a071193911","779":"6df3f7df2f4b5c931e4d"}[chunkId] + ".js";
};